import CustomForm from '../../lib/FormValidator/Form/CustomForm';
import { Club } from '../../system/Club/Club';
import { Equipo } from '../../system/Equipo/Equipo';
import { Fase } from '../../system/Fase/Fase';
import { Federacion } from '../../system/Federacion/Federacion';
import { Partido } from '../../system/Partido/Partido';
import { TorneoZonaXFase } from '../../system/TorneoZonaXFase/TorneoZonaXFase';

import { PartidoOfflineAssertions } from '../../system/PlanillaPartidoOffline/PartidoOfflineAssertions';
import TorneoOfflineForm from './TorneoOfflineform';

class PartidoOfflineForm extends CustomForm {
  private torneo: TorneoOfflineForm;

  protected constructor(paro_id: string | null, paro_club_local: string, paro_club_visitante: string) {
    const paroff = PartidoOfflineAssertions.build();
    super('PartidoOffline', paroff);
    this.addInputAsserted('paro_id', paro_id);
    this.addInput('paro_club_local', paro_club_local);
    this.addInput('paro_club_visitante', paro_club_visitante);

    this.torneo = TorneoOfflineForm.initialize();
    this.addFormInput(this.torneo);
  }

  private static build(paro_id: string | null, paro_club_local: string, paro_club_visitante: string) {
    return new this(paro_id, paro_club_local, paro_club_visitante);
  }

  static initialize() {
    return this.build(null, '', '');
  }

  toPartido(eq_local_id: string, eq_visitante_id: string): Partido {
    return Partido.createFrom(
      this.getIdInput().getValue(),
      0,
      new Date(),
      '',
      0,
      +eq_local_id,
      +eq_visitante_id,
      null,
      null,
      null,
      null,
      '',
      true,
      null,
      true,
      true,
      Fase.createFrom(
        '',
        '',
        '',
        0,
        0,
        '',
        1,
        this.getTorneoForm().toTorneo().getTorneoTipo()!,
        this.getTorneoForm().toTorneo(),
        [],
        [TorneoZonaXFase.createFrom('', '', 'A', null)]
      ),
      Equipo.createFrom(
        eq_local_id,
        '',
        0,
        '',
        '',
        '',
        true,
        0,
        0,
        true,
        [],
        Club.createFrom(
          null,
          this.getClubLocalInput().getValue(),
          '',
          0,
          '',
          '',
          '',
          '',
          true,
          '',
          0,
          0,
          Federacion.createFrom(null, '', '', '', '', '', '', true, '')
        )
      ),
      Equipo.createFrom(
        eq_visitante_id,
        '',
        0,
        '',
        '',
        '',
        true,
        0,
        0,
        true,
        [],
        Club.createFrom(
          null,
          this.getClubVisitanteInput().getValue(),
          '',
          0,
          '',
          '',
          '',
          '',
          true,
          '',
          0,
          0,
          Federacion.createFrom(null, '', '', '', '', '', '', true, '')
        )
      ),
      null, //campo
      null,
      null,
      null,
      null,
      null,
      null,
      false,
      null,
      null,
      0,
      0
    );
  }

  getIdInput() {
    return this.getInputByName('paro_id');
  }

  getClubLocalInput() {
    return this.getInputByName('paro_club_local');
  }

  getClubVisitanteInput() {
    return this.getInputByName('paro_club_visitante');
  }

  getTorneoForm() {
    return this.torneo;
  }
}

export default PartidoOfflineForm;
